import { FunctionComponent, useState, useEffect } from 'react'
import { Box, Typography } from '@material-ui/core'
import { CreatePostModal } from './CreatePostModal'
import { BackendUser, Content } from 'common/types'
import { useTheme } from 'styled-components'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { Button } from 'common/atoms/Button/Button'
import { useHistory, useLocation } from 'react-router-dom'
import { Add } from '@material-ui/icons'

interface CreatePostsProps {
  user: BackendUser
  createContent: Function
  showClearModal: boolean
  setShowClearModal: Function
  showEdit: boolean
  setShowEdit: Function
  setPosts: Function
  posts: Content[]
  myPosts: Content[]
  setMyPosts: Function
  setShowLoader: Function
  tabIndex: Number
  notify: Function
  showCreatePost: boolean
  setShowCreatePost: Function
}
export const CreatePost: FunctionComponent<CreatePostsProps> = ({
  user,
  createContent,
  setShowEdit,
  setPosts,
  posts,
  myPosts,
  setMyPosts,
  setShowLoader,
  showCreatePost,
  setShowCreatePost
}) => {

  const history = useHistory()
  const [showSuccessChip, setShowSuccessChip] = useState(false)
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const location = useLocation()

  const handleCreatePost = () => {
    setShowCreatePost(true)
    setShowSuccessChip(false)
  }


  const handleCreatePostNotification = new URLSearchParams(location?.search).get('createPost')
  useEffect(() => {
    if (handleCreatePostNotification == 'true') {
      history.push('/feed')
      handleCreatePost()
    }
  }, [handleCreatePostNotification])

  return (
    <Box position="relative">
      <Box
        marginLeft="auto"
        marginBottom={isDevice ? '0.5em' : 0}
      >
        <Button 
          design='secondary' 
          fullWidth
          onClick={() => isDevice ? history.push('/createPost') : handleCreatePost()}
          rightIcon={<Add />}
        >
          Create Post
        </Button>
      </Box>
      <Box>
        <CreatePostModal
          show={showCreatePost}
          setShow={setShowCreatePost}
          setShowSuccessChip={setShowSuccessChip}
          title=""
          noborder
          createContent={createContent}
          setShowEdit={setShowEdit}
          setPosts={setPosts}
          onClose={() => {
            setShowCreatePost(false)
          }}
          user={user}
          posts={posts}
          myPosts={myPosts}
          setMyPosts={setMyPosts}
          setShowLoader={setShowLoader}
        />
      </Box>
    </Box>
  )
}
